/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * a Role
 * @export
 * @interface ApiRole
 */
export interface ApiRole {
    /**
     * 
     * @type {number}
     * @memberof ApiRole
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiRole
     */
    name: string;
}

/**
 * Check if a given object implements the ApiRole interface.
 */
export function instanceOfApiRole(value: object): value is ApiRole {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ApiRoleFromJSON(json: any): ApiRole {
    return ApiRoleFromJSONTyped(json, false);
}

export function ApiRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiRole {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
    };
}

export function ApiRoleToJSON(json: any): ApiRole {
    return ApiRoleToJSONTyped(json, false);
}

export function ApiRoleToJSONTyped(value?: ApiRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

